import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* setCompressionRateOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCompressionRateOptions])
    const { entity } = response
    yield put(actions.setCompressionRateOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setCompressionRateOptions() error: ${e}`))
  }
}
export function* setCompressionRateOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCompressionRateOptions)
}
